import { useIntl } from 'react-intl';

const FormattedDateTime = ({ value, withTime }) => {
  const context = useIntl();

  const localeFromContext = context && context.locale;

  const setLocale = localeFromContext || 'en';

  const setOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(withTime && {
      hour: 'numeric',
      minute: 'numeric'
    })
  };

  const date = new Date(value);
  let formattedDate = null;

  try {
    formattedDate = new Intl.DateTimeFormat(setLocale, setOptions).format(date).replace(',', '');
  } catch (e) {}

  return formattedDate || '-';
};

export default FormattedDateTime;
